import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download } from "lucide-react";

// QR card with a PNG download. `url` is what the phone opens when scanned.
export const JQRCard = ({ url, title, caption, fileName, testid }) => {
  const box = useRef(null);
  const download = () => {
    const canvas = box.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `${fileName}.png`;
    a.click();
  };
  return (
    <div data-testid={testid} className="flex items-center gap-4 rounded-[10px] bg-[#0E2A1C] border border-[#F2B441]/40 p-3 pr-5">
      <div ref={box} className="shrink-0 rounded-[6px] bg-[#F6EEDC] p-2">
        <QRCodeCanvas value={url} size={256} level="M" bgColor="#F6EEDC" fgColor="#0E2A1C" className="!w-[88px] !h-[88px]" data-testid={`${testid}-code`} />
      </div>
      <div className="min-w-0">
        <p className="font-mono-d text-[11px] tracking-[0.2em] uppercase text-[#F2B441]">{title}</p>
        <p className="text-xs text-[#C9D6C2] mt-1 leading-relaxed">{caption}</p>
        <button onClick={download} data-testid={`${testid}-download`}
          className="mt-2 inline-flex items-center gap-1.5 text-xs font-semibold text-[#F6EEDC] hover:text-[#F2B441] transition-colors">
          <Download className="w-3.5 h-3.5" /> Descargar QR
        </button>
      </div>
    </div>
  );
};
